<template>
    <div v-if="link.Type == 'SessionCategory'"
         :class="[displayClasses]" :id="contactInfoId" @click="raiseClick">
        <h4 v-if="link.DisplayText">{{link.DisplayText}}</h4>
        <div v-if="categorySessions.length > 0" class="session-category-cards">
            <router-link v-for="session in categorySessions" :key="session.Code"
                         :to="{name: 'agendaDetails', params: {code: session.Code}}"
                         custom v-slot="{href, navigate}">
                <a :href="href" class="session-category-card" @click="onSessionClick($event, navigate)">
                    <div class="session-category-poster">
                        <template v-if="session.PrimaryMedia && session.PrimaryMedia.ThumbnailUri && thumbnailStates[session.PrimaryMedia.ThumbnailUri] != 'error'">
                            <img :key="session.PrimaryMedia.ThumbnailUri"
                                 :src="session.PrimaryMedia.ThumbnailUri" :alt="session.Name"
                                 :class="{'thumbnail-loaded': thumbnailStates[session.PrimaryMedia.ThumbnailUri] == 'loaded'}"
                                 @load="setThumbnailState($event, 'loaded')"
                                 @error="setThumbnailState($event, 'error')">
                            <div v-if="thumbnailStates[session.PrimaryMedia.ThumbnailUri] != 'loaded'"
                                 class="session-category-loading" role="status" aria-label="Loading thumbnail">
                                <loading size="small"></loading>
                            </div>
                            <span v-else class="session-category-play icomoon" aria-hidden="true">&#xea1c;</span>
                        </template>
                        <span v-else>Video</span>
                    </div>
                    <div class="session-category-name">
                        <span class="session-category-title">{{session.Name}}</span>
                        <span v-if="session.HasWebinarAccessPassword" class="icomoon" title="Password required" aria-label="Password required"></span>
                        <div v-if="session.Headlines" class="session-category-headline">{{session.Headlines}}</div>
                    </div>
                </a>
            </router-link>
        </div>
        <p v-else>No sessions in this category.</p>
        <component :is="'style'" v-if="link.Style" v-html="styleTagContents"></component>
    </div>
    <div v-else-if="link.Type == 'Section' || (editMode && (link.Type == 'LoginHeader' || link.Type == 'LoginFooter'))"
         :class="[displayClasses]"
         :id="contactInfoId"
         @click="raiseClick">
        <h1 v-if="link.DisplayText">
            {{link.DisplayText}}
        </h1>
        <div v-if="link.Details" 
             v-html="markdown(link.Details)">
        </div>
        <component :is="'style'" 
                   v-if="link.Style"
                   v-html="styleTagContents">
        </component>
        <div v-if="editMode"
             class="edit-mode-drag-overlay">

        </div>
    </div>
    <div v-else-if="link.Type == 'Image'" 
         :class="[displayClasses]"
         @click="raiseClick"
         :id="contactInfoId">
        <img-g :src="link.IconUrl" class="responsive" />

        <span v-if="link.Details">
            {{link.Details}}
        </span>
    </div>
    <div v-else 
         :class="[displayClasses]"
         @click="raiseClick"
         :id="contactInfoId">
        <div class="icomoon link-icon"
             :class="{'photo-icon': link.Type == 'TractusLink' && (isAttendeeLink || isVendorLink)}">
            <div v-if="link.Type == 'Website' || link.Type == 'Downloadable'">{{ getIconForContactInfo(link) }}</div>
            <div v-else-if="link.Type == 'Email'">{{ getIconForContactInfo(link) }}</div>
            <div v-else-if="showDisplayPhoto">{{ getEntityPhoto(link.Value) }}</div>
            <img-g v-else :src="getEntityPhoto(link.Value)" fallbackSrc="/img/person.png" />
        </div>
        <div class="info-details">
            <div class="info-link-title">
                {{link.DisplayText}}
            </div>
            <div class="info-link-subtitle" v-if="link.Details">{{link.Details}}</div>
        </div>
        <div v-if="link && link.Type == 'Downloadable'" class="action-container">
            <a :href="link.Value" 
               target="_blank"
               class="icomoon round-button button-outline" 
               @click.stop="logClickDownloadEvent">
                
            </a>    
        </div>
    </div>
</template>
<script>
import Common from "./common";
import { AppState } from "./appstate";

export default {
    mixins: [Common],

    props: [
        "entityType", 
        "entityCode",
        "link",
        "index",
        'editMode',
        'sessions'
    ],

    data() {
        return {
            thumbnailStates: {}
        };
    },

    computed: {
        categorySessions() {
            let categoryCode = (this.link.Value || '').toUpperCase();
            if(!categoryCode) {
                return [];
            }
            if(!AppState.show || !(AppState.show.SessionCategories || []).some(category => category.Code.toUpperCase() == categoryCode)) {
                return [];
            }
            let sessions = (this.sessions || []).filter(session => {
                let primaryCode = session.Category ? session.Category.Code : '';
                return (primaryCode || '').toUpperCase() == categoryCode
                    || (session.SubCategoryCodes || []).some(code => (code || '').toUpperCase() == categoryCode);
            });
            return sessions.sort((left, right) => {
                let comparison = (left.Name || '').localeCompare(right.Name || '', 'en', {sensitivity: 'base'});
                if(comparison != 0) {
                    return comparison;
                }
                let leftCode = (left.Code || '').toUpperCase();
                let rightCode = (right.Code || '').toUpperCase();
                if(leftCode < rightCode) {
                    return -1;
                }
                if(leftCode > rightCode) {
                    return 1;
                }
                if(left.Code < right.Code) {
                    return -1;
                }
                if(left.Code > right.Code) {
                    return 1;
                }
                return 0;
            });
        },
        showDisplayPhoto() {
            if(!this.link.Type == 'TractusLink')
                return false;
            
            if(!this.link.Value) {
                return false;
            }

            if(this.link.Value.localeCompare('attendee', 'en', {
                sensitivity: 'accent'
            }) === 0) {
                return true;
            }

            if(this.link.Value.localeCompare('vendor', 'en', {
                sensitivity: 'accent'
            }) === 0) {
                return true;
            }

            return false;
        },

        contactInfoId() {
            return `ci_${this.index}`;
        },

        styleTagContents() {
            if(!this.link.Style) {
                return null;
            }

            return this.link.Style.replaceAll("#ci_ID", `#ci_${this.index}`);
        },

        displayClasses() {
            let classAdd = "info-link";

            if(this.link.Type == 'Section' || this.link.Type == 'SessionCategory' || this.link.Type == 'LoginHeader' || this.link.Type == 'LoginFooter') {
                classAdd = 'info-link-section'
            } else if(this.link.Type == 'Image') {
                classAdd = 'info-link-image';
            }

            if(this.link.Value && this.link.Type != 'SessionCategory'){
                classAdd = `${classAdd} info-link-clickable`;
            }

            if(!this.link.Size) {
                return `${classAdd} info-link-full-width`;
            }

            const size = this.link.Size == 'Fluid' ? 'Full' : this.link.Size;
            return `${classAdd} info-link-${size.toLowerCase()}-width info-link-item`;
        },

        isAttendeeLink() {
            return this.link
                && this.link.Type == 'TractusLink'
                && this.link.Value.indexOf('//Attendee') != -1;
        },

        isVendorLink() {
            return this.link
                && this.link.Type == 'TractusLink'
                && this.link.Value.indexOf('//Vendor') != -1;
        },

        
    },

    methods: {
        setThumbnailState(event, state) {
            this.thumbnailStates[event.currentTarget.getAttribute('src')] = state;
        },
        onSessionClick(event, navigate) {
            if(this.editMode) {
                event.preventDefault();
            } else {
                event.stopPropagation();
                navigate(event);
            }
        },
        raiseClick() {
            if(this.editMode) {
                this.$emit('openlink', this.link);
            } else {
                if(!this.link.Value && this.link.Type == "Image"){
                    return;
                }

                this.$emit('openlink', this.link);
            }
        },

        logClickDownloadEvent() {
            if(this.editMode) {
                return;
            }
            
            this.postAnalytics(
                AppState.attendeeCode,
                "Download",
                this.entityCode,
                this.entityType,
                AppState.showCode,
                this.link.Value
            );            
        },
    }
}
</script>
<style scoped>
.session-category-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1rem;
}
.session-category-card {
    display: block;
    color: inherit;
    text-decoration: none;
    outline: 1px solid transparent;
    outline-offset: 2px;
    transition: outline-color 0.15s ease, box-shadow 0.15s ease;
}
.session-category-card:hover,
.session-category-card:focus-visible {
    outline-color: var(--primary-color);
    box-shadow: 0 0 6px color-mix(in srgb, var(--primary-color) 15%, transparent);
}
.session-category-poster {
    width: 100%;
    aspect-ratio: 16 / 9;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--light-bg-color);
}
.session-category-poster img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
}
.session-category-poster img.thumbnail-loaded {
    opacity: 1;
}
.session-category-loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.session-category-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    padding-left: 0.15rem;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid var(--full-bright-bg-color, #fff);
    background: var(--full-dark-bg-color, #000);
    color: var(--full-bright-bg-color, #fff);
    font-size: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
    opacity: 0.85;
    pointer-events: none;
}
.session-category-name {
    padding: 0.5rem 0;
}
.session-category-title {
    font-weight: 600;
}
.session-category-headline {
    font-size: 0.875rem;
    color: var(--subtle-text-color);
}
</style>
